import { Component, ChangeDetectorRef } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ErrorHandler } from "../shared/services/error-handler.service";
import { SessionHandler } from "../shared/services/session-handler.service";
import { HttpService } from "../shared/services/http.service";
import { CommonService } from "../shared/services/common.service";
import { LayoutService } from "../layout/layout.service";
import { APPCONFIG } from "../config";
import { MdDialog, MdDialogRef } from "@angular/material";
// import { dialogComponent,icbtermsDialogComponent,privacyComponent } from '../../../dialog/dialog.component';

import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { config } from "process";
import { TranslateService } from "ng2-translate";
import { dialogComponent } from "../dialog/dialog.component";
import { filter } from "rxjs/operators";
declare const gapi: any;

@Component({
  selector: "app-login",
  styles: [require('./login.component.scss')],
  template: require('./login.component.html'),
  providers: [],
})
export class PageLoginComponent {
  dialogRef;
  showLandingpage: boolean = false;
  PartnersForm: FormGroup;
  languageList:any;
	selectedLanguage:any;
  previousUrl: any;
  currentUrl: string;

  constructor(
    private router: Router,
    public httpService: HttpService,
    private http: HttpClient,
    public errorHandler: ErrorHandler,
    public layoutService: LayoutService,
    public sessionHandler: SessionHandler,
    public commonService: CommonService,
    private dialog: MdDialog,
    private ref: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      console.log("prev=",this.previousUrl,'current=',this.currentUrl)
      if(this.previousUrl){
        this.commonService.setLoginRedirectUrl(this.previousUrl)
      }
    });
    this.buildForm();

		this.languageList = translate.getLangs();
    this.selectedLanguage =this.sessionHandler.getItem("defaultLanguage");
		this.selectedLanguage?this.translate.use(this.selectedLanguage):'';

  }

  userDetails: any;
  ngOnInit() {
    
}
 
  public saveResponse(res){
   console.log(this.commonService.getLoginRedirectUrl())
    if(res.errorStatus == 'Fail') {
        this.httpService.onEnd();   
        if(res.errorMessage) {
            //alert(res.errorMessage); 
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;               
        } else {
            //alert('Login failed. Please try again.');
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = "Login failed. Please try again";
        }
    } else {
	
      localStorage.removeItem('redirect');

    		this.sessionHandler.saveItem("loginData", JSON.stringify(res));

        this.sessionHandler.saveItem("userDetails", JSON.stringify(this.userDetails));
        this.sessionHandler.saveItem("country", res.country);
        this.sessionHandler.saveItem('token',res.accessToken);
        console.log(res.appAccess.toLowerCase())

        const roles = res.role || [];

        if (this.commonService.isOnlyFOCRole(roles)) {

          this.sessionHandler.saveItem("allAccess", 'false');

          let redirectUrl = '#/app/foc_dashboard';

          if (this.commonService.getLoginRedirectUrl() && this.commonService.getLoginRedirectUrl().toLowerCase().includes('foc')) {
            redirectUrl = '#' + this.commonService.getLoginRedirectUrl();
          }

          window.location.href = redirectUrl;
          return;
        }
        

  /**New access conditions */
      if(res.appAccess.toLowerCase()=='wrt'){
        this.sessionHandler.saveItem("allAccess", 'false');
        let redirectUrl = '#/app/dashboard';
        if(!res.role || res.role.length < 1){
          //alert('No role assigned to user. Please contact your administrator.');
          this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = "No role assigned to user. Please contact your administrator";
        } else if(this.commonService.getLoginRedirectUrl()) {
          redirectUrl = '#'+this.commonService.getLoginRedirectUrl();
          window.location.href=redirectUrl;
        }else {
          window.location.href=redirectUrl;
        }
      }else if(res.appAccess.toLowerCase()=='icb'){
        this.showLandingpage = true;
        this.sessionHandler.saveItem("allAccess", 'false');
        this.sessionHandler.saveItem("icbUser", 'true');
        let redirectUrl = '#/app/icb/dashboard';
        if(this.commonService.getLoginRedirectUrl()) {
          redirectUrl = '#'+this.commonService.getLoginRedirectUrl();
          window.location.href=redirectUrl;
        }else {
          window.location.href=redirectUrl;
        }
        // window.location.href=redirectUrl;
        this.ref.detectChanges();
      }else if(res.appAccess.toLowerCase()=='both'){
        this.showLandingpage = true;
        this.sessionHandler.saveItem("allAccess", 'true');
        let redirectUrl = '#/app/home';
         if(this.commonService.getLoginRedirectUrl()) {
          redirectUrl = '#'+this.commonService.getLoginRedirectUrl();
          window.location.href=redirectUrl;
        }else {
          window.location.href=redirectUrl;
        }
        // window.location.href=redirectUrl;
        this.ref.detectChanges();
      }
  /**End */


  }
  this.commonService.setLoginRedirectUrl(null)

}


  buildForm() {
    this.PartnersForm = new FormGroup({
      userId_WPASS: new FormControl(""),
      password: new FormControl(""),
      loginAsMaster: new FormControl(true),
      language:new FormControl("")
    });
  }
  returnToolNavigate() {
    window.location.href = "#/app/dashboard";
  }

  icbNavigate() {
    window.location.href = "#/app/icb/dashboard";
  }

  ngAfterViewInit() {
    //this.googleInit();
  }

  redirectRegistration() {
    window.open(APPCONFIG.ESRP_FRONTEND_URL + "/#/registration", "_blank");
  }
  redirectForgotPassword() {
    window.open(APPCONFIG.ESRP_FRONTEND_URL + "/#/forgot-password", "_blank");
  }
  redirectUnlockWpassAccount() {
    window.open(APPCONFIG.ESRP_FRONTEND_URL + "/#/unlock-account", "_blank");
  }
  showPassword(input: any): any {
    input.type = input.type === "password" ? "text" : "password";
  }
  wpassLogin() {
    //For self registration login
    const httpOptions = {
      headers: new HttpHeaders(APPCONFIG.ESRP_API_CALL_Header),
    };
    console.log(this.PartnersForm.value.loginAsMaster);
    let body = JSON.stringify(this.PartnersForm.value);
    this.httpService.showLoader();
    console.log(
      APPCONFIG.ESRP_BACKEND_URL + "/_ah/api/externalOperations/v1/wpassLogin"
    );
    console.log(httpOptions);
    this.http
      .post(
        APPCONFIG.ESRP_BACKEND_URL +
          "/_ah/api/externalOperations/v1/wpassLogin",
        body,
        httpOptions
      )

      .subscribe(
        (res) => {
          this.httpService.onEnd();
          this.addUpdatePartnerDetails(res);
        },
        (err) => {
          // this.httpService.onEnd();
          console.log(err)
          if (APPCONFIG.esrpErrorTexts[err.error.error.message]) {
            this.layoutService.popToast(
              APPCONFIG.esrpErrorTexts[err.error.error.message],
              APPCONFIG.toastrType.error
            );
          } else {
            this.layoutService.popToast(
              "Login failed. Please try again.",
              APPCONFIG.toastrType.error
            );
          }
        }
      );
  }
  addUpdatePartnerDetails(partnerDetails) {
    if (!partnerDetails.userId_WPASS) {
      return false;
    }
    partnerDetails.wpassId = partnerDetails.userId_WPASS;
    partnerDetails.wpassRole = partnerDetails.role_WPASS;

    this.userDetails = {
      token: "vgfgf",
      id: 77567,
      name: partnerDetails.firstName + " " + partnerDetails.lastName,
      image: "https://ssl.gstatic.com/s2/profiles/images/silhouette200.png",
      email: partnerDetails.email,
    };
    this.httpService
      .postRequest(
        partnerDetails,
        "userOperationsApi/v1/addOrUpdateEsrpUserDetails"
      )
      .subscribe(
        (res) => {
          this.httpService.onEnd();
          // this.partnerLogin(res);
        },
        (err) => {
          this.httpService.onEnd();
          this.layoutService.popToast(
            "Login failed. Please try again.",
            APPCONFIG.toastrType.error
          );
        }
      );
  }

  partnerLogin(userData?) {
    let formdata = this.PartnersForm.value;
    let body={
      userId : formdata.userId_WPASS,
      password:formdata.password,
      language:formdata.language
    }
    localStorage.removeItem('loginData');
    this.httpService
      .postRequest(body, "userOperationsApi/v1/wpassLogin")
      .subscribe(
        (res) => {
          this.httpService.onEnd();
          this.saveResponse(res);
          this.userDetails = {
            token: "vgfgf",
            id: 77567,
            name: res["userName"],
            image:
              "https://ssl.gstatic.com/s2/profiles/images/silhouette200.png",
            email: res["email"],
          };
          this.sessionHandler.saveItem(
            "userDetails",
            JSON.stringify(this.userDetails)
          );
          this.sessionHandler.saveItem("country", res["country"]);
        },
        (err) => {
          this.httpService.onEnd();
          
          // this.layoutService.popToast(
          //   "Login failed. Please try again.",
          //   APPCONFIG.toastrType.error
          // );
        }
      );
  }

  public languageSave() {
		console.log("AXXXXXXX")
		this.commonService.changeLanguage(this.selectedLanguage);
		this.translate.use(this.selectedLanguage);
		this.sessionHandler.saveItem("defaultLanguage",this.selectedLanguage);
		// this.dialog.closeAll();
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/login/login.component.ts